import { GOAL_APP_FEED_PATH, GOAL_FEED_PAGE, GOAL_FEED_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const goalUpdateViewRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: GOAL_FEED_PAGE,
	path: GOAL_FEED_PATH,
	capabilities: ['goals_app:access'],
	layout: 'home',
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
});

export const goalsAppUpdateViewRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: GOAL_FEED_PAGE,
	path: GOAL_APP_FEED_PATH,
	capabilities: ['goals_app:access'],
	layout: 'home',
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
});
